import { Card, CardContent } from "../components/ui/card"
import { Button } from "../components/ui/button"
import { Brain, Target, Zap, Users, ArrowLeft, Sparkles, GraduationCap } from "lucide-react"

export function LearnMorePage({ onBack }) {
  const features = [
    {
      icon: Brain,
      title: "AI-Powered Assessment",
      description: "Get accurate evaluations tailored for the 2025 Anglia tests.",
    },
    {
      icon: Target,
      title: "Targeted Test Preparation",
      description: "Practice with materials designed for the 2025 Anglia test format.",
    },
    {
      icon: Zap,
      title: "Rapid Progress Tracking",
      description: "Monitor your improvement with instant feedback on test performance.",
    },
    {
      icon: Users,
      title: "Personalized Test Path",
      description: "Follow a customized study plan adapting to your test results.",
    },
  ]

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="pt-24 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-8">
            <Button
              onClick={onBack}
              variant="ghost"
              className="bg-white/80 backdrop-blur-md shadow-lg rounded-lg px-4 py-2"
            >
              <ArrowLeft className="mr-2 h-4 w-4" /> Back to Tests
            </Button>
          </div>
          <Card className="overflow-hidden">
            <CardContent className="p-8">
              <div className="text-center mb-12">
                <GraduationCap className="w-16 h-16 mx-auto mb-4 text-blue-600" />
                <h1 className="text-4xl font-bold text-gray-900 mb-4">Prepare for 2025 Anglia Papers with AI</h1>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Our AI-powered platform is specifically designed to help you excel in the upcoming 2025 Anglia English
                  tests.
                </p>
              </div>
              <div className="grid gap-8 md:grid-cols-2">
                {features.map((feature, index) => (
                  <Card
                    key={index}
                    className="overflow-hidden transition-all duration-300 hover:shadow-lg border-none bg-gradient-to-br from-blue-50 to-indigo-100"
                  >
                    <CardContent className="p-6">
                      <feature.icon className="w-12 h-12 mb-4 text-blue-600" />
                      <h2 className="text-xl font-semibold mb-2 text-gray-900">{feature.title}</h2>
                      <p className="text-gray-600">{feature.description}</p>
                    </CardContent>
                  </Card>
                ))}
              </div>
              <Card className="mt-12 overflow-hidden transition-all duration-300 hover:shadow-lg border-none bg-gradient-to-br from-purple-50 to-pink-100">
                <CardContent className="p-8 text-center">
                  <Sparkles className="w-12 h-12 text-yellow-400 mx-auto mb-4" />
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">2025 Anglia Tests Focus</h2>
                  <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                    Our tests are continuously updated to align with the latest 2025 Anglia exam formats. Practice with
                    confidence, knowing you're preparing with the most relevant and up-to-date materials available.
                  </p>
                </CardContent>
              </Card>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
